var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestrictedAccessMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43,40h-2.6124878L28.8974609,5.5292969C28.1938477,3.4179688,26.2255859,2,24,2s-4.1938477,1.4179688-4.8974609,3.5292969 L7.6124878,40H5c-1.6542969,0-3,1.3457031-3,3s1.3457031,3,3,3h38c1.6542969,0,3-1.3457031,3-3S44.6542969,40,43,40z M43,44H5 c-0.5512695,0-1-0.4482422-1-1s0.4487305-1,1-1h3h32h3c0.5512695,0,1,0.4482422,1,1S43.5512695,44,43,44z M24,4 c1.3632812,0,2.5688477,0.8691406,3,2.1621094L31.6126709,20H16.3873291L21,6.1621094C21.4311523,4.8691406,22.6367188,4,24,4z  M32.2793579,22l2.000061,6H13.7205811l2.000061-6H32.2793579z M13.0539551,30h21.8920898L38.27948,40H9.72052L13.0539551,30z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedAccessMedium);
export default __webpack_public_path__ + "static/media/restricted-access--medium.4b8554570bc0cbdafbf1b6f1dc776dc1.svg";
export { ForwardRef as ReactComponent };